import { useTranslation } from 'react-i18next';
import { Icon } from '../ui/kit.js';
import './rename-field.css';

/**
 * A suggested name, offered rather than applied.
 *
 * Amber, dashed: something the panel thought of and is waiting on the parent
 * for, which is what amber means everywhere else in it.
 */
export const SuggestionChip = ({
  onClick,
  labelled = false,
  children,
}: {
  onClick: () => void;
  /** Prefix the text with "Suggestion:", where the chip stands alone. */
  labelled?: boolean;
  children: string;
}) => {
  const { t } = useTranslation();

  return (
    <button type="button" className="cp-suggest" onClick={onClick}>
      <Icon name="spark" small />
      <span>{labelled ? t('collectionPage.suggestion', { title: children }) : children}</span>
    </button>
  );
};
